import { TeButtonMinimal, TeCallout } from '@topcon/tuicl-react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const CalloutWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const CalloutAction = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
`;

interface MigrationCalloutProps {
  descriptionText: string;
  buttonLabel: string;
  onButtonClicked: () => void;
}

function MigrationCallout({
  descriptionText,
  buttonLabel,
  onButtonClicked,
}: MigrationCalloutProps) {
  const { t } = useTranslation('common');
  return (
    <CalloutWrapper>
      <TeCallout
        status="warning"
        icon="warning"
        grow
        heading={t('migrationCallout.reviewTitle')}
        text={descriptionText}
        style={{ borderColor: '#8F4D01' }}
      />
      <CalloutAction>
        <TeButtonMinimal
          text={buttonLabel}
          variant="secondary"
          size="s"
          teclick={onButtonClicked}
        />
      </CalloutAction>
    </CalloutWrapper>
  );
}

export { MigrationCallout };
